var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormHelper',{ref:"form",attrs:{"config":_vm.formConfig,"form":_vm.form},on:{"change":_vm.onFormFieldChange},model:{value:(_vm.formValues),callback:function ($$v) {_vm.formValues=$$v},expression:"formValues"}})
}
var staticRenderFns = []

export { render, staticRenderFns }